import { TextProps } from "@chakra-ui/react";
import CDS from "design-system";

type TextErrorProps = TextProps;

export default function DefaultErrorText({ children, ...props }: TextErrorProps) {
  return (
    <CDS.Text10 {...props} color="error.DEFAULT" lineHeight="normal">
      {children}
    </CDS.Text10>
  );
}
